import { Center, Text, VStack } from '@chakra-ui/react';
import { Location } from 'history';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthentication } from '~auth/useAuthentication';
import { useQueryParams } from '../UseQueryParams';

type LoginState = {
  from?: Location;
};

export function LoginPage() {
  const location = useLocation();
  const state = location.state as LoginState | undefined;
  const query = useQueryParams();

  const { loginWithRedirect, error } = useAuthentication();

  useEffect(() => {
    if (error) {
      return;
    }

    void loginWithRedirect({
      authorizationParams: {
        login_hint: query.get('email') ?? undefined,
      },
      appState: {
        returnTo: state?.from?.pathname,
      },
    });
  }, [error, loginWithRedirect, query, state]);

  return error ? (
    <Center width="100%" height="100vh">
      <VStack>
        <Text>Unauthorized</Text>
        <Text>Please contact an administrator.</Text>
      </VStack>
    </Center>
  ) : null;
}
